import { useState } from "react";

import { useHeadContact } from "@/entities/head-contacs/api/api";
import { Modal } from "@/shared/ui/Modal";

export const CollaborateModal = () => {
  const { data } = useHeadContact();
  const headContact = data?.data.data.contact;

  return (
    <div className="flex flex-col items-center gap-2">
      <Modal>
        <Modal.Trigger className="w-full rounded">Сотрудничество</Modal.Trigger>

        <Modal.Content className="mx-auto max-w-lg rounded-lg bg-white p-6 shadow-lg">
          <Modal.Title className="mb-4 text-2xl font-bold">
            Сотрудничайте с нами!
          </Modal.Title>

          <p className="font-medium text-gray-700">Суть партнерства:</p>
          <ul className="mb-4 list-inside list-disc space-y-1 text-gray-600">
            <li>Гибкий процент</li>
            <li>Дополнительная отчетность по лидам</li>
            <li>Моментальное рассмотрение потребностей</li>
            <li>Возможно выделение бюджетов</li>
            <li>И многое другое</li>
          </ul>

          <p className="font-medium text-gray-700">
            Для того чтобы стать партнером, отправьте анкету в следующем
            формате:
          </p>
          <ol className="list-inside list-decimal space-y-1 text-gray-600">
            <li>Подробно о вашем источнике</li>
            <li>Подробно о вашем опыте работы</li>
            <li>Необходимость бюджетов</li>
            <li>Примерная стоимость лида</li>
            <li>Минимальный и максимальный объем</li>
            <li>
              Тестовый, неоплачиваемый залив на 50–100 лидов для понимания
              качества
            </li>
            <li>
              Контакт для связи: <span className="font-semibold">@finpepe</span>
            </li>
          </ol>
        </Modal.Content>
      </Modal>

      {headContact && (
        <Modal>
          <Modal.Trigger className="rounded px-3 py-2 text-sm font-medium">
            Резервный контакт
          </Modal.Trigger>

          <Modal.Content className="mx-auto max-w-md rounded-lg bg-white p-6 shadow-lg">
            <Modal.Title className="text-xl font-bold">
              Резервный контакт
            </Modal.Title>

            <p className="mt-2 text-sm text-gray-600">
              Используйте этот контакт, если основной недоступен
            </p>

            <ContactCopyField value={headContact} />
          </Modal.Content>
        </Modal>
      )}
    </div>
  );
};

const ContactCopyField = ({ value }: { value: string }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="mt-4 rounded-xl border border-gray-200 bg-gray-50 p-4">
      <p className="mb-2 text-sm font-medium text-gray-600">
        Контакт для связи
      </p>

      <div className="flex items-center gap-2">
        <div className="flex-1 truncate rounded-lg bg-white px-3 py-2 font-mono text-sm text-gray-800 shadow-inner">
          {value}
        </div>

        <button
          onClick={handleCopy}
          className="rounded-lg bg-black px-4 py-2 text-sm font-medium text-white transition hover:bg-gray-800 active:scale-95"
        >
          {copied ? "Скопировано" : "Копировать"}
        </button>
      </div>
    </div>
  );
};
